import React from 'react';
import TopicsAgentPage from '../components/TopicsAgentPage';
import { API_ENDPOINTS } from '../config/api';
import { loadProductTopicGroups } from '../data/productArticleTopics';

const PSBArticlesAgentPage: React.FC = () => (
  <TopicsAgentPage
    pageTitle="PSB Articles Agent"
    pageDescription="Generate Plant Super Boost articles centered on live microbes, the soil food web, ecosystem recovery, and why living biology does the invisible heavy lifting for plant health."
    storageKeyPrefix="psb_articles_agent"
    generateAsyncUrl={API_ENDPOINTS.psbArticlesGenerateAsync}
    getJobStatusUrl={API_ENDPOINTS.psbArticlesJobStatus}
    loadGroups={() =>
      loadProductTopicGroups({
        path: '/keywords/psb_blogs - Plant Super Boost.csv',
        prefix: 'psb',
      })
    }
  />
);

export default PSBArticlesAgentPage;
